export const pinterest = [
  {
    rank: 1,
    name: "Pic1",
    description: "I’m stuck.",
    image: "https://i.pinimg.com/736x/c2/7c/bc/c27cbc0cf1985fd7fcc1f3687c1b0ed5.jpg",
    url: "https://i.pinimg.com/736x/c2/7c/bc/c27cbc0cf1985fd7fcc1f3687c1b0ed5.jpg",
  },
  {
    rank: 2,
    name: "Pic2",
    description: "I’m stuck.",
    image: "https://i.pinimg.com/736x/2c/bf/d5/2cbfd501977e3b3a0112ba44e2764432.jpg",
    url: "https://i.pinimg.com/736x/2c/bf/d5/2cbfd501977e3b3a0112ba44e2764432.jpg",
  },
  {
    rank: 3,
    name: "Pic3",
    description: "I’m stuck.",
    image: "https://i.pinimg.com/736x/d5/b8/f8/d5b8f8b921b3b94deafb91f8c6393813.jpg",
    url: "https://i.pinimg.com/736x/d5/b8/f8/d5b8f8b921b3b94deafb91f8c6393813.jpg",
  },
  {
    rank: 4,
    name: "Pic4",
    description: "I’m stuck.",
    image: "https://i.pinimg.com/1200x/bc/b9/95/bcb9956eaca7c1c088557478c5a70798.jpg",
    url: "https://i.pinimg.com/1200x/bc/b9/95/bcb9956eaca7c1c088557478c5a70798.jpg",
  },
  {
    rank: 5,
    name: "Pic5",
    description: "I’m stuck.",
    image: "https://i.pinimg.com/736x/9e/6c/85/9e6c85210079231598f56c67439a55e9.jpg",
    url: "https://i.pinimg.com/736x/9e/6c/85/9e6c85210079231598f56c67439a55e9.jpg",
  },
  {
    rank: 6,
    name: "Pic6",
    description: "I’m stuck.",
    image: "https://i.pinimg.com/736x/d6/86/54/d68654d6f2cf7508195ac9c8ed83babd.jpg",
    url: "https://i.pinimg.com/736x/d6/86/54/d68654d6f2cf7508195ac9c8ed83babd.jpg",
  },
];
